// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.last-scan-results {
    background: white;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    margin-bottom: 30px;
}

.last-scan-results h3 {
    margin: 0 0 15px 0;
    font-size: 18px;
    color: #333;
}

.loading-small,
.error-small {
    padding: 15px;
    text-align: center;
    color: #666;
    font-size: 14px;
}

.error-small {
    color: #d32f2f;
    background: #ffebee;
    border-radius: 4px;
}

.no-scans {
    text-align: center;
    color: #999;
    font-style: italic;
    padding: 20px;
    margin: 0;
}

.scan-table-wrapper {
    overflow-x: auto;
    max-height: 400px;
    overflow-y: auto;
}

.scan-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
}

.scan-table thead {
    position: sticky;
    top: 0;
    background: #f5f5f5;
    z-index: 1;
}

.scan-table th {
    padding: 12px 10px;
    text-align: left;
    font-weight: 600;
    color: #555;
    border-bottom: 2px solid #ddd;
    white-space: nowrap;
}

.scan-table td {
    padding: 12px 10px;
    border-bottom: 1px solid #eee;
}

.scan-table tbody tr:hover {
    background: #f9f9f9;
}

.scan-table tbody tr:last-child td {
    border-bottom: none;
}

/* Column-specific styling */
.timestamp {
    color: #666;
    font-size: 13px;
    white-space: nowrap;
}

.scanner-name {
    font-weight: 500;
    color: #333;
}

.document-type,
.country {
    color: #666;
}

/* Status badges */
.status-badge,
.validation-badge,
.scan-type-badge {
    display: inline-block;
    padding: 4px 10px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
}

.status-success {
    background: #e8f5e9;
    color: #2e7d32;
}

.status-failed {
    background: #ffebee;
    color: #c62828;
}

.validation-passed {
    background: #e3f2fd;
    color: #1565c0;
}

.validation-failed {
    background: #fff3e0;
    color: #e65100;
}

.scan-type-badge.single-sided {
    background: #f3e5f5;
    color: #6a1b9a;
}

.scan-type-badge.double-sided {
    background: #e1f5fe;
    color: #01579b;
}

/* Security checks */
.security-checks {
    white-space: nowrap;
}

.check-ratio {
    font-weight: 600;
    color: #333;
}

.failed-count {
    margin-left: 6px;
    font-size: 12px;
    color: #d32f2f;
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .scan-table {
        font-size: 12px;
    }

    .scan-table th,
    .scan-table td {
        padding: 8px 6px;
    }

    .last-scan-results {
        padding: 15px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/LastScanResults.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,wCAAwC;IACxC,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,WAAW;AACf;;AAEA;;IAEI,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,4BAA4B;AAC5B;IACI,WAAW;IACX,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;;IAEI,WAAW;AACf;;AAEA,kBAAkB;AAClB;;;IAGI,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA,oBAAoB;AACpB;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA,2BAA2B;AAC3B;IACI;QACI,eAAe;IACnB;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":[".last-scan-results {\n    background: white;\n    border-radius: 8px;\n    padding: 20px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    margin-bottom: 30px;\n}\n\n.last-scan-results h3 {\n    margin: 0 0 15px 0;\n    font-size: 18px;\n    color: #333;\n}\n\n.loading-small,\n.error-small {\n    padding: 15px;\n    text-align: center;\n    color: #666;\n    font-size: 14px;\n}\n\n.error-small {\n    color: #d32f2f;\n    background: #ffebee;\n    border-radius: 4px;\n}\n\n.no-scans {\n    text-align: center;\n    color: #999;\n    font-style: italic;\n    padding: 20px;\n    margin: 0;\n}\n\n.scan-table-wrapper {\n    overflow-x: auto;\n    max-height: 400px;\n    overflow-y: auto;\n}\n\n.scan-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 14px;\n}\n\n.scan-table thead {\n    position: sticky;\n    top: 0;\n    background: #f5f5f5;\n    z-index: 1;\n}\n\n.scan-table th {\n    padding: 12px 10px;\n    text-align: left;\n    font-weight: 600;\n    color: #555;\n    border-bottom: 2px solid #ddd;\n    white-space: nowrap;\n}\n\n.scan-table td {\n    padding: 12px 10px;\n    border-bottom: 1px solid #eee;\n}\n\n.scan-table tbody tr:hover {\n    background: #f9f9f9;\n}\n\n.scan-table tbody tr:last-child td {\n    border-bottom: none;\n}\n\n/* Column-specific styling */\n.timestamp {\n    color: #666;\n    font-size: 13px;\n    white-space: nowrap;\n}\n\n.scanner-name {\n    font-weight: 500;\n    color: #333;\n}\n\n.document-type,\n.country {\n    color: #666;\n}\n\n/* Status badges */\n.status-badge,\n.validation-badge,\n.scan-type-badge {\n    display: inline-block;\n    padding: 4px 10px;\n    border-radius: 12px;\n    font-size: 12px;\n    font-weight: 600;\n    text-transform: uppercase;\n}\n\n.status-success {\n    background: #e8f5e9;\n    color: #2e7d32;\n}\n\n.status-failed {\n    background: #ffebee;\n    color: #c62828;\n}\n\n.validation-passed {\n    background: #e3f2fd;\n    color: #1565c0;\n}\n\n.validation-failed {\n    background: #fff3e0;\n    color: #e65100;\n}\n\n.scan-type-badge.single-sided {\n    background: #f3e5f5;\n    color: #6a1b9a;\n}\n\n.scan-type-badge.double-sided {\n    background: #e1f5fe;\n    color: #01579b;\n}\n\n/* Security checks */\n.security-checks {\n    white-space: nowrap;\n}\n\n.check-ratio {\n    font-weight: 600;\n    color: #333;\n}\n\n.failed-count {\n    margin-left: 6px;\n    font-size: 12px;\n    color: #d32f2f;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n    .scan-table {\n        font-size: 12px;\n    }\n\n    .scan-table th,\n    .scan-table td {\n        padding: 8px 6px;\n    }\n\n    .last-scan-results {\n        padding: 15px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
